import * as tagColor from './CountTag.module.scss';
import './AppCountTag.scss';
import { AppstoreOutlined } from '@ant-design/icons';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { CountTag } from './CountTag';
import { DirectionalAppList } from '@ui/applications';
import { Popover } from 'antd';
import { SonarText } from '@ui/text';
import uniq from 'lodash/uniq';
import { useSonarObjectReference } from '@hooks';
import React, { useMemo } from 'react';
export const AppCountTag = ({ sonarObjectId }) => {
    const { ingestedBy, populatedBy } = useSonarObjectReference(sonarObjectId);
    const notMonitored = populatedBy.length === 1 && populatedBy[0] === -1;
    const count = useMemo(() => {
        if (notMonitored) {
            return ingestedBy.length;
        }
        return uniq(ingestedBy.concat(populatedBy)).length;
    }, [ingestedBy, populatedBy, notMonitored]);
    return (React.createElement(Popover, { classNames: { root: 'app-count-tag-popover' }, content: React.createElement(DirectionalAppList, { direction: 'vertical', ingestingAppIds: ingestedBy, populatingAppIds: notMonitored ? [] : populatedBy }), placement: 'bottom', title: React.createElement(SonarText, { weight: 'semibold' }, COPY_SPECIFIC.INTEGRATED_APP_USAGE), trigger: 'hover' },
        React.createElement(CountTag, { className: 'app-count-tag', color: tagColor.appCount, count: count, icon: React.createElement(AppstoreOutlined, null), visible: Boolean(count) })));
};
